/**
 * Extend general error to see specific errors in Sentry
 */
export class RecruitmentError extends Error {
    constructor(message: string) {
        super(message)

        this.name = 'RecruitmentError'

        // 👇️ because we are extending a built-in class
        Object.setPrototypeOf(this, RecruitmentError.prototype)
    }
}
